<br><br>
    <div class="page-wrapper bg-gra-03 p-t-45 p-b-50">
        <div  class="wrapper wrapper--w790">
            
            <div class="card card-5">
                <div class="card-heading">
                    
                    <h2 class="title">نلوج على ماكينة أكسيجين</h2>
                </div>
                
                <div class="card-body d-flex justify-content-center">
                    
              <form   style="text-align: center; " [formGroup]="OxygenForm" (ngSubmit)="onSubmit()">                        <div class="form-row">
                            <div class="name">الولاية*</div>


                            
                            <div class="value">
                                <div class="input-group">
                                    <div class="rs-select2 js-select-simple select--no-search">
                                        <select style="margin-right: 180px;" class="select-css" (change)="onChange($event.target.value)" formControlName="region"  name="subject">
                                            <option disabled="disabled" selected="selected">إختار الولاية</option>
                                            <option *ngFor="let region of regions">{{region}}</option>

                                        </select>
                                        <div class="select-dropdown"></div>
                                    </div>
                                </div>
                                <div style="font-size: 12px; color: red; ">لازم تعمر هذا (*) </div>

                            </div>
                        </div>
                        <div class="form-row">
                            <div class="name">المعتمدية</div>
                            <div class="value">
                                <div class="input-group">
                                    <div class="rs-select2 js-select-simple select--no-search">
                                        <select style="margin-right: 180px;" class="select-css" formControlName="villa" name="subject">
                                            <option disabled="disabled" selected="selected">إختار المعتمدية</option>
                                            
                                            <option  [ngValue]="v" *ngFor="let v of ville">{{v}}</option>
  
                                          
                                        </select>
                                        <div class="select-dropdown"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                        <div>
                            <button *ngIf="!showSpinner" class="btn btn--radius-2 btn--red" type="submit">لوج</button>
                            <button *ngIf="showSpinner" class="btn btn--radius-2 btn--red" type="submit">
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                تحميل...
                              </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

  
